import { render, staticRenderFns } from "./UpdateBillingAddress.vue?vue&type=template&id=bf9c8a24"
import script from "./UpdateBillingAddress.vue?vue&type=script&lang=js"
export * from "./UpdateBillingAddress.vue?vue&type=script&lang=js"
import style0 from "./UpdateBillingAddress.vue?vue&type=style&index=0&id=bf9c8a24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports